import type { FieldChange, FieldVersionHistory } from '@/hooks/useVersionHistory';
import type { DealDetailsFormField } from '../types';

export type SectionMetadata = {
  lastChangedAt: string | null;
  lastChangedBy: string | null;
};

/**
 * Get the most recent change information for a section based on its fields
 * @param versionHistory - Map of field names to their version history
 * @param fields - Array of fields that belong to this section
 * @returns Section metadata with last change timestamp and user's name
 */
export const getSectionMetadata = (
  versionHistory: Map<string, FieldVersionHistory> | undefined,
  fields: DealDetailsFormField[],
): SectionMetadata => {
  if (!versionHistory || fields.length === 0) {
    return { lastChangedAt: null, lastChangedBy: null };
  }

  let mostRecentChange: Pick<FieldChange, 'changedAt' | 'changedBy'> | null = null;

  fields.forEach(field => {
    const fieldHistory = versionHistory.get(field.key as string);
    if (fieldHistory?.latestChange) {
      const { changedAt, changedBy } = fieldHistory.latestChange;

      if (!mostRecentChange || new Date(changedAt) > new Date(mostRecentChange.changedAt)) {
        mostRecentChange = { changedAt, changedBy };
      }
    }
  });

  return {
    lastChangedAt: mostRecentChange ? mostRecentChange.changedAt : null,
    lastChangedBy: mostRecentChange ? mostRecentChange.changedBy : null,
  };
};
